import hu from "./admin_menuitem_help_hu";

export default {
	...hu,
	menuitem_help_open_section: "打开分区帮助",
	menuitem_minimum_price_label: "最低价格",
	menuitem_help_details_intro: "此分区用于定义产品的标识与描述信息。",
	menuitem_help_details_1: "设置分类和别名，便于内部管理。",
	menuitem_help_details_2: "为每种语言填写本地化名称和描述。",
	menuitem_help_details_3: "添加主图和平台专用图片，以获得更好的展示效果。",
	menuitem_help_general_intro: "在此分区配置商品在业务流程中的行为。",
	menuitem_help_general_1: "选择单位类型、时段、税率类别和生产线。",
	menuitem_help_general_2: "分配标签、NTAK 分类和条码。",
	menuitem_help_general_3: "这些设置会影响税务、后厨流程和平台集成。",
	menuitem_help_quantities_intro: "在这里控制定价策略和可售规格。",
	menuitem_help_quantities_1: "设置采购成本、基础售价和预期利润率。",
	menuitem_help_quantities_2: "管理规格行及各平台专属价格和附加费。",
	menuitem_help_quantities_fix_quantity: "固定数量表示该商品只能按预设数量销售。关闭后，销售时可以自由输入售出数量，例如按重或按量售卖的商品。",
	menuitem_help_quantities_col_default: "默认标记：该规格会在点单界面自动被选中。",
	menuitem_help_quantities_col_top: "置顶标记：将该规格作为重点展示并可排在更显眼位置。",
	menuitem_help_quantities_col_inventory_item: "库存标记：定义该规格是否作为库存跟踪项管理。",
	menuitem_help_quantities_col_quantity: "该规格在所选单位下的数量值（例如 2 cl、4 cl、1000 g）。",
	menuitem_help_quantities_col_name: "该规格在点单界面显示的名称。",
	menuitem_help_quantities_col_selling_price: "该规格的毛销售价格。",
	menuitem_help_quantities_col_package_charge: "该规格的容器或包装费用（饮品为容器费，其他商品为包装费）。",
	menuitem_help_quantities_col_label_count: "该规格需要打印的标签数量。",
	menuitem_help_quantities_col_price_per_cost_ratio: "显示该规格的销售价与计算成本的比值。",
	menuitem_help_quantities_col_price_estimation: "系统为该规格计算的建议价格。",
	menuitem_help_quantities_col_purchase_price: "与该规格关联的采购成本。",
	menuitem_help_quantities_3: "可通过促销设置活动名称、数值和生效时间。",
	menuitem_help_recipes_intro: "定义商品配方和可定制选项。",
	menuitem_help_recipes_1: "标记过敏原和热量信息。",
	menuitem_help_recipes_2: "配置必选、包含和可选加料。",
	menuitem_help_recipes_3: "使用继承选项以保持分类级别的一致性。",
	menuitem_help_recipes_allergens: "通过过敏原标记，可在点单界面和小票上清晰提示该商品可能包含的过敏原。",
	menuitem_help_recipes_calorie: "在此填写商品自身热量值。系统可叠加必选配料的计算热量，以显示更准确的总热量。",
	menuitem_help_recipes_mandatory: "必选加料始终属于该商品。你也可以在这里设置必选用量；继承的必选加料会显示在单独列表中。",
	menuitem_help_recipes_included: "包含加料属于默认配方，但通常可在下单时调整或去除。继承的包含加料会单独显示。",
	menuitem_help_recipes_optional: "可选加料是顾客可自行选择的附加项，常用于加价销售。继承的可选加料会在单独列表中显示。",
	menuitem_help_links_intro: "此分区显示与该商品相关的依赖信息。",
	menuitem_help_links_1: "查看该商品在哪些地方被引用。",
	menuitem_help_links_2: "在重大修改前用它评估影响范围。",
	menuitem_help_links_3: "该列表仅用于参考，不能直接编辑。",
	menuitem_help_creation_workflow: "要创建新产品、选项、配料或任何非类别的内容，请选择父类别，然后单击\"新建项目\"按钮以打开菜单项编辑器。填写所需字段，必填字段为名称和数量类型。NTAK类别、增值税和时间安排默认应设置为\"inherit\"。填写完字段后，保存菜单项。如需创建更多产品，请再次单击\"新建项目\"。",
	menuitem_help_category_creation_workflow: "要创建类别，如果不需要父类别，请使用\"新建顶级类别\"按钮——这样它将作为根级类别创建。如果该类别需要嵌套在现有类别下，请先选择父类别，然后使用\"新建项目\"按钮创建，并将类型设置为类别。",
	menuitem_help_multi_item_creation: "当需要在指定类别中创建多个项目时（例如\"在配料类别中创建蘑菇、火腿、玉米\"），优先使用foreach循环：将项目放入实体数组（如entities.menu_items），生成一个对其进行迭代的单一foreach组，包含打开编辑器、设置名称、设置数量类型、设置继承字段和保存的子步骤。这将产生一个紧凑、可重用的计划。只有当每个项目需要结构上不同的步骤时，才为每个项目使用显式的顺序组。"
};
